import * as yup from "yup";

// Common field validations
export const requiredStringSchema = (fieldName: string) =>
  yup.string().required(`${fieldName} is required`);

export const optionalStringSchema = yup.string().optional();

export const phoneSchema = yup
  .string()
  .matches(/^[+]?([1-9][\d]{0,15})$/, "Please enter a valid phone number")
  .required("Phone number is required");

export const nameSchema = yup
  .string()
  .min(2, "Name must be at least 2 characters")
  .max(50, "Name must be less than 50 characters")
  .matches(/^[a-zA-Z\s]*$/, "Name can only contain letters and spaces")
  .required("Name is required");

// Date validations
export const dateOfBirthSchema = yup
  .date()
  .max(new Date(), "Date of birth cannot be in the future")
  .required("Date of birth is required");

// Professional validations
export const licenseNumberSchema = yup
  .string()
  .min(3, "License number must be at least 3 characters")
  .required("License number is required");
